module.exports = __webpack_public_path__ + "686c38e90655dded8a7b9808f7217020.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/mug.jpg
// module id = 602
// module chunks = 0